/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import store from '@/store';
import { USER, SECRET, GAME } from '@/store/types';
import { finalizeAction, StoreActionEnv, ActionType } from '@/store/actions';
import * as api from '@/api/user';
import { UserGameItem } from '@/api/types/user';

export interface StoreUserGameState {
  games: UserGameItem[];
  id: number;
}

export default {
  namespaced: true,
  state: {
    games: null,
    id: null,
  },
  actions: {
    [USER.GET_GAMES](
      { commit, state }: StoreActionEnv<StoreUserGameState>,
      { action: rawAction, id }: { action: ActionType; id: number } = { action: '', id: 0 },
    ) {
      const action = finalizeAction(rawAction, state.games && state.id === id);
      if (action) {
        return new Promise<void>((resolve, reject) => {
          api.getGames(id).then((res) => {
            commit(USER.GET_GAMES, {
              games: res.data,
              id,
            });
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
    [USER.SET_GAME](_, { id, body }) {
      return new Promise((resolve, reject) => {
        api.setGame(id, body).then((res) => {
          const ps: Promise<void>[] = [];
          if (body.userId) {
            // 退圈后刷新用户已加入的游戏列表
            ps.push(store.dispatch(`user/game/${USER.GET_GAMES}`, { id: body.userId, action: 'refresh' }));
            // 加入游戏后刷新未加入的游戏列表
            ps.push(store.dispatch(`game/${GAME.GET_GAMES}`, { filter: 'other', action: 'refresh' }));
          }
          ps.push(store.dispatch(`user/${USER.GET}`, { action: 'refresh' }));
          ps.push(store.dispatch(`user/game/${USER.GET_GAMES}`, { action: 'refresh' }));
          ps.push(store.dispatch(`secret/room/${SECRET.GET_ROOM}`, { action: 'refresh' }));
          ps.push(store.dispatch(`user/profile/${USER.GET_GAME_OPTIONS}`, { action: 'refresh', scene: 'detail', id }));
          ps.push(store.dispatch(`user/profile/${USER.GET_GAME_OPTIONS}`, { action: 'reload', scene: 'start', id }));
          ps.push(store.dispatch(`secret/room/${SECRET.GET_ROOM_LIST_ALL}`, { action: 'refresh', scene: 'post' }));
          Promise.all(ps).then(() => { resolve(res); }).catch(reject);
        }).catch(reject);
      });
    },
  },
  mutations: {
    [USER.GET_GAMES](state: StoreUserGameState, { games, id }: { games: UserGameItem[]; id: number }) {
      state.games = games;
      state.id = id;
    },
  },
};
